import LegalLayout from "./LegalLayout";

export default function ImpressumPage() {
  return (
    <LegalLayout title="Impressum" kicker="Rechtliches">
      <h2>Angaben gemäß § 5 ECG / § 25 MedienG</h2>
      <p>
        <strong>Eljhat Kadrii e.U.</strong><br />
        Hernalser Hauptstraße 135<br />
        1170 Wien, Österreich
      </p>

      <h3>Kontakt</h3>
      <p>
        Telefon: <a href="tel:+436764440304">+43 676 4440304</a><br />
        WhatsApp: <a href="https://wa.me/436764440304">+43 676 4440304</a><br />
        E-Mail: <a href="mailto:store@hausdeshandys.at">store@hausdeshandys.at</a>
      </p>

      <h3>Unternehmensdaten</h3>
      <p>
        Inhaber: Eljhat Kadrii<br />
        Rechtsform: Einzelunternehmen (e.U.)<br />
        Firmenbuchnummer: <strong>FN 628945w</strong><br />
        Firmenbuchgericht: Handelsgericht Wien<br />
        UID-Nummer: <strong>ATU81376119</strong><br />
        Steuernummer: 12 654/2885<br />
        EORI-Nummer: ATEOS1000152074
      </p>

      <h3>Kammerzugehörigkeit / Berufsrecht</h3>
      <p>
        Mitglied der Wirtschaftskammer Wien.<br />
        Anwendbare gewerberechtliche Vorschrift: Gewerbeordnung 1994 (GewO), abrufbar unter&nbsp;
        <a href="https://www.ris.bka.gv.at" target="_blank" rel="noreferrer">www.ris.bka.gv.at</a>.
      </p>

      <h3>Aufsichtsbehörde</h3>
      <p>Magistratisches Bezirksamt für den 17. Bezirk, Wien</p>

      <h3>EU-Streitschlichtung</h3>
      <p>
        Plattform der EU-Kommission zur Online-Streitbeilegung:&nbsp;
        <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">https://ec.europa.eu/consumers/odr/</a>.
        Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <h3>Haftung für Inhalte</h3>
      <p>
        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit
        und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
      </p>

      <h3>Haftung für Links</h3>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
        Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
      </p>

      <h3>Urheberrecht</h3>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
        österreichischen Urheberrecht.
      </p>
    </LegalLayout>
  );
}
